// @flow
import { createTheme } from '@material-ui/core/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#021c49',
      contrastText: '#ffffff',
      '50': '#e1e4e9',
      '100': '#b3bbc8',
      '200': '#818ea4',
      '300': '#4e6080',
      '400': '#283e64',
      '500': '#021c49',
      '600': '#021942',
      '700': '#011439',
      '800': '#011131',
      '900': '#010921',
    },
    secondary: {
      main: '#ff9500',
      contrastText: '#ffffff',
      '50': '#fff3e0',
      '100': '#ffe2b3',
      '200': '#ffce80',
      '300': '#ffba4d',
      '400': '#ffac26',
      '500': '#ff9d00',
      '600': '#ff9500',
      '700': '#ff8b00',
      '800': '#ff8100',
      '900': '#ff6f00',
    },
    error: {
      main: '#b24848',
      contrastText: '#ffffff',
      '50': '#f7eaea',
      '100': '#eacaca',
      '200': '#dca7a7',
      '300': '#ce8484',
      '400': '#c46969',
      '500': '#b94f4f',
      '600': '#b24848',
      '700': '#aa3f3f',
      '800': '#a23636',
      '900': '#932626',
    },
    grey: {
      '50': '#f2f2f2',
      '100': '#dedede',
      '200': '#c8c8c8',
      '300': '#b2b2b2',
      '400': '#a2a2a2',
      '500': '#919191',
      '600': '#898989',
      '700': '#7e7e7e',
      '800': '#747474',
      '900': '#626262',
    },
    success: {
      '50': '#e7efe3',
      '100': '#c2d7b9',
      '200': '#99bc8a',
      '300': '#70a15b',
      '400': '#528c38',
      '500': '#337815',
      '600': '#2e7012',
      '700': '#27650f',
      '800': '#205b0c',
      '900': '#144806',
    },
  },
  typography: {
    fontFamily: [
      '"geomanist"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Helvetica Neue"',
      'sans-serif',
    ].join(','),
  },
});

export default theme;
